import { type WeightFormSchema, weightNumberFields, weightUnitField } from "@msuite/utils/schemas";
import { weightUnits } from "@msuite/utils/units";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "../localization";
import { InputGroup } from "./input-group";
import { NumberInput } from "./number-input";
import { Select } from "./select";

export function WeightInput() {
	/** Context */
	const methods = useFormContext<WeightFormSchema>();
	const weightUnit = useWatch({ control: methods.control, name: "weightUnit" });

	/** Hooks */
	const { t } = useTranslation();

	return (
		<div className="grid grid-cols-[1fr_150px] gap-x-4">
			<InputGroup>
				{weightNumberFields.map((field) => {
					return (
						<NumberInput
							key={field}
							hideButtons
							isRequired={false}
							label={t(`calculations.${field}`)}
							control={methods.control}
							name={field}
							min={0}
							variant={weightUnit}
							step={0.01}
						/>
					);
				})}
			</InputGroup>
			<Select
				isRequired
				label={t("units.unit")}
				isNullable={false}
				control={methods.control}
				name={weightUnitField}
				defaultValue="kilogram"
				errorVariant="tooltip"
				options={weightUnits.map((unit) => ({
					label: t(`units.${unit}`),
					value: unit,
					item: { unit },
				}))}
			/>
		</div>
	);
}
